/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/watchlist/watchlist-proxy.module';
import * as i2 from '../../../$$_gendir/node_modules/ngx-bootstrap/dropdown/bs-dropdown-container.component.ngfactory';
import * as i3 from '../../../$$_gendir/node_modules/ngx-bootstrap/modal/modal-backdrop.component.ngfactory';
import * as i4 from '../../../$$_gendir/node_modules/ngx-bootstrap/modal/modal-container.component.ngfactory';
import * as i5 from '../../../$$_gendir/node_modules/@nw/ui-watchlist/components/watchlist.component.ngfactory';
import * as i6 from '@angular/common';
import * as i7 from '@angular/forms';
import * as i8 from 'ngx-bootstrap/positioning/positioning.service';
import * as i9 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i10 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i11 from 'ngx-bootstrap/modal/bs-modal.service';
import * as i12 from '@nw/ui-core-shared/services/mfe-redirection.service';
import * as i13 from '@nw/ui-core-shared/services/environment.service';
import * as i14 from '@nw/ui-core-shared/services/user-preferences-timezone.service';
import * as i15 from '@nw/ui-core-shared/store/main-store.service';
import * as i16 from '@angular/http';
import * as i17 from '@ngrx/effects/src/bootstrap-listener';
import * as i18 from '@ngrx/effects/src/effects-subscription';
import * as i19 from '@ngrx/store-devtools/src/extension';
import * as i20 from '@ngrx/store-devtools/src/devtools';
import * as i21 from '@ngrx/store-devtools/src/config';
import * as i22 from '@ngrx/store-devtools/src/instrument';
import * as i23 from '@ngrx/store/src/dispatcher';
import * as i24 from '@ngrx/store/src/reducer';
import * as i25 from '@ngrx/store/src/ng2';
import * as i26 from '@nw/dealerblock-bid-ui/shared/services/dealerblock-bid.service';
import * as i27 from '@angular/common/http';
import * as i28 from '@nw/dealerblock-bid-ui/shared/services/dealerblock-best-offer.service';
import * as i29 from '@nw/dealerblock-bid-ui/shared/services/dealerblock-best-offer-history.service';
import * as i30 from 'ngx-bootstrap/tabs/tabset.config';
import * as i31 from 'ngx-bootstrap/accordion/accordion.config';
import * as i32 from '@nw/ui-watchlist/store/actions/WatchlistIotActions';
import * as i33 from '@nw/ui-watchlist/shared/services/iot-handler.service';
import * as i34 from '@nw/ui-core-shared/services/iot-access.service';
import * as i35 from '@nw/ui-core-shared/services/message.service';
import * as i36 from '@nw/ui-core-shared/services/session.service';
import * as i37 from '@ngrx/store/src/store';
import * as i38 from '@nw/ui-watchlist/shared/services/vehicle-note.service';
import * as i39 from '@nw/ui-watchlist/shared/services/vehicle-liveblock-auction.service';
import * as i40 from '@angular/router';
import * as i41 from 'ngx-bootstrap/dropdown/bs-dropdown.module';
import * as i42 from 'ngx-bootstrap/collapse/collapse.module';
import * as i43 from 'ngx-bootstrap/modal/modal.module';
import * as i44 from '@ngx-translate/core/index';
import * as i45 from '@nw/ui-core-shared/shared.module';
import * as i46 from 'ngx-bootstrap/tabs/tabs.module';
import * as i47 from '@nw/ui-watchlist/watchlist.module';
import * as i48 from '@ngrx/store/src/state';
import * as i49 from '@ngrx/effects/src/actions';
import * as i50 from '@nw/ui-core-shared/services/jwt.interceptor';
import * as i51 from '@nw/ui-watchlist/shared/services/vehicles.service';
import * as i52 from '@nw/ui-watchlist/store/actions/WatchListActions';
import * as i53 from '@nw/ui-watchlist/shared/services/vehicle-filter.service';
import * as i54 from '@nw/ui-core-shared/services/local-storage.service';
import * as i55 from '@ngx-translate/core/src/translate.store';
import * as i56 from '@ngx-translate/core/src/translate.loader';
import * as i57 from '@ngx-translate/core/src/translate.compiler';
import * as i58 from '@ngx-translate/core/src/translate.parser';
import * as i59 from '@ngx-translate/core/src/missing-translation-handler';
import * as i60 from '@ngx-translate/core/src/translate.service';
import * as i61 from '@nw/ui-watchlist/shared/services/vehicle-sort.service';
import * as i62 from '@nw/ui-watchlist/store/effects/VehiclesEffects';
import * as i63 from '@nw/ui-core-shared/services/utility.service';
import * as i64 from '@nw/ui-core-shared/store/actions/app-ui.action';
import * as i65 from '@ngrx/effects/src/effects.module';
import * as i66 from '@nw/dealerblock-bid-ui/dealerblock.module';
import * as i67 from 'ngx-bootstrap/accordion/accordion.module';
import * as i68 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
import * as i69 from '@nw/ui-watchlist/components/watchlist.component';
export const WatchlistProxyModuleNgFactory:i0.NgModuleFactory<i1.WatchlistProxyModule> = i0.ɵcmf(i1.WatchlistProxyModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i2.BsDropdownContainerComponentNgFactory,i3.ModalBackdropComponentNgFactory,
              i4.ModalContainerComponentNgFactory,i5.WatchlistComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,i6.NgLocalization,
          i6.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i7.ɵi,i7.ɵi,([] as any[])),
          i0.ɵmpd(4608,i8.PositioningService,i8.PositioningService,([] as any[])),
          i0.ɵmpd(4608,i9.ComponentLoaderFactory,i9.ComponentLoaderFactory,[i0.ComponentFactoryResolver,
              i0.NgZone,i0.Injector,i8.PositioningService,i0.ApplicationRef]),i0.ɵmpd(4608,
              i10.BsDropdownState,i10.BsDropdownState,([] as any[])),i0.ɵmpd(4608,
              i11.BsModalService,i11.BsModalService,[i9.ComponentLoaderFactory]),i0.ɵmpd(4608,
              i12.MfeRedirectionService,i12.MfeRedirectionService,[i13.EnvironmentService]),
          i0.ɵmpd(4608,i14.UserPreferencesTimezoneService,i14.UserPreferencesTimezoneService,
              [i15.MainStoreService]),i0.ɵmpd(4608,i16.ɵg,i16.ɵg,([] as any[])),i0.ɵmpd(4608,
              i16.JSONPBackend,i16.ɵa,[i16.ɵg,i16.ResponseOptions]),i0.ɵmpd(5120,i16.Jsonp,
              i16.ɵd,[i16.JSONPBackend,i16.RequestOptions]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,
              (p0_0:any,p0_1:any) => {
                return [i17.runAfterBootstrapEffects(p0_0,p0_1)];
              },[i0.Injector,i18.EffectsSubscription]),i0.ɵmpd(4608,i19.DevtoolsExtension,
              i19.DevtoolsExtension,[i19.REDUX_DEVTOOLS_EXTENSION]),i0.ɵmpd(4608,i20.DevtoolsDispatcher,
              i20.DevtoolsDispatcher,([] as any[])),i0.ɵmpd(5120,i21.STORE_DEVTOOLS_CONFIG,
              i22._createOptions,[i21.INITIAL_OPTIONS]),i0.ɵmpd(4608,i20.StoreDevtools,
              i20.StoreDevtools,[i20.DevtoolsDispatcher,i23.Dispatcher,i24.Reducer,
                  i19.DevtoolsExtension,i25.INITIAL_STATE,i21.STORE_DEVTOOLS_CONFIG]),
          i0.ɵmpd(4608,i26.DealerBlockBidService,i26.DealerBlockBidService,[i27.HttpClient]),
          i0.ɵmpd(4608,i28.DealerblockBestOfferService,i28.DealerblockBestOfferService,
              ([] as any[])),i0.ɵmpd(4608,i29.DealerblockBestOfferHistoryService,i29.DealerblockBestOfferHistoryService,
              [i27.HttpClient]),i0.ɵmpd(4608,i30.TabsetConfig,i30.TabsetConfig,([] as any[])),
          i0.ɵmpd(4608,i31.AccordionConfig,i31.AccordionConfig,([] as any[])),i0.ɵmpd(4608,
              i32.WatchlistIotActions,i32.WatchlistIotActions,([] as any[])),i0.ɵmpd(4608,
              i33.IotHandlerService,i33.IotHandlerService,[i34.IotAccessService,i35.MessageService,
                  i36.SessionService,i37.Store,i32.WatchlistIotActions]),i0.ɵmpd(4608,
              i38.VehicleNoteService,i38.VehicleNoteService,[i27.HttpClient,i36.SessionService,
                  i37.Store]),i0.ɵmpd(4608,i39.VehicleLiveblockAuctionService,i39.VehicleLiveblockAuctionService,
              ([] as any[])),i0.ɵmpd(512,i6.CommonModule,i6.CommonModule,([] as any[])),
          i0.ɵmpd(512,i7.ɵba,i7.ɵba,([] as any[])),i0.ɵmpd(512,i7.FormsModule,i7.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i40.RouterModule,i40.RouterModule,[[2,i40.ɵa],
              [2,i40.Router]]),i0.ɵmpd(512,i16.HttpModule,i16.HttpModule,([] as any[])),
          i0.ɵmpd(512,i27.HttpClientXsrfModule,i27.HttpClientXsrfModule,([] as any[])),
          i0.ɵmpd(512,i27.HttpClientModule,i27.HttpClientModule,([] as any[])),i0.ɵmpd(512,
              i41.BsDropdownModule,i41.BsDropdownModule,([] as any[])),i0.ɵmpd(512,
              i42.CollapseModule,i42.CollapseModule,([] as any[])),i0.ɵmpd(512,i43.ModalModule,
              i43.ModalModule,([] as any[])),i0.ɵmpd(512,i44.TranslateModule,i44.TranslateModule,
              ([] as any[])),i0.ɵmpd(512,i45.NwSharedModule,i45.NwSharedModule,([] as any[])),
          i0.ɵmpd(512,i16.JsonpModule,i16.JsonpModule,([] as any[])),i0.ɵmpd(512,i46.TabsModule,
              i46.TabsModule,([] as any[])),i0.ɵmpd(512,i25.StoreModule,i25.StoreModule,
              ([] as any[])),i0.ɵmpd(512,i23.Dispatcher,i23.Dispatcher,([] as any[])),
          i0.ɵmpd(1024,i19.REDUX_DEVTOOLS_EXTENSION,i22._createReduxDevtoolsExtension,
              ([] as any[])),i0.ɵmpd(256,i25._INITIAL_REDUCER,i47.watchlistReducer,
              ([] as any[])),i0.ɵmpd(1024,i25.INITIAL_REDUCER,i25._initialReducerFactory,
              [i25._INITIAL_REDUCER]),i0.ɵmpd(1024,i24.Reducer,i22._createReducerIfExtension,
              [i19.REDUX_DEVTOOLS_EXTENSION,i0.Injector,i25.INITIAL_REDUCER]),i0.ɵmpd(256,
              i25._INITIAL_STATE,(undefined as any),([] as any[])),i0.ɵmpd(1024,i25.INITIAL_STATE,
              i25._initialStateFactory,[i25._INITIAL_STATE,i25.INITIAL_REDUCER]),i0.ɵmpd(1024,
              i48.State,i22._createStateIfExtension,[i19.REDUX_DEVTOOLS_EXTENSION,
                  i0.Injector,i25.INITIAL_STATE]),i0.ɵmpd(1024,i37.Store,i25._storeFactory,
              [i23.Dispatcher,i24.Reducer,i48.State]),i0.ɵmpd(512,i49.Actions,i49.Actions,
              [i23.Dispatcher]),i0.ɵmpd(512,i27.ɵd,i27.ɵd,([] as any[])),i0.ɵmpd(2048,
              i27.XhrFactory,(null as any),[i27.ɵd]),i0.ɵmpd(512,i27.HttpXhrBackend,
              i27.HttpXhrBackend,[i27.XhrFactory]),i0.ɵmpd(2048,i27.HttpBackend,(null as any),
              [i27.HttpXhrBackend]),i0.ɵmpd(256,i27.ɵe,'XSRF-TOKEN',([] as any[])),
          i0.ɵmpd(512,i27.HttpXsrfTokenExtractor,i27.ɵg,[i6.DOCUMENT,i0.PLATFORM_ID,
              i27.ɵe]),i0.ɵmpd(256,i27.ɵf,'X-XSRF-TOKEN',([] as any[])),i0.ɵmpd(512,
              i27.ɵh,i27.ɵh,[i27.HttpXsrfTokenExtractor,i27.ɵf]),i0.ɵmpd(1024,i27.HTTP_INTERCEPTORS,
              (p0_0:any) => {
                return [p0_0,new i50.JWTInterceptor()];
              },[i27.ɵh]),i0.ɵmpd(1024,i27.HttpHandler,i27.ɵinterceptingHandler,[i27.HttpBackend,
              [2,i27.HTTP_INTERCEPTORS]]),i0.ɵmpd(512,i27.HttpClient,i27.HttpClient,
              [i27.HttpHandler]),i0.ɵmpd(512,i51.VehiclesService,i51.VehiclesService,
              [i27.HttpClient,i13.EnvironmentService,i40.ActivatedRoute]),i0.ɵmpd(512,
              i52.WatchListActions,i52.WatchListActions,([] as any[])),i0.ɵmpd(512,
              i53.VehicleFilterService,i53.VehicleFilterService,[i37.Store,i52.WatchListActions,
                  i54.LocalStorageService]),i0.ɵmpd(512,i55.TranslateStore,i55.TranslateStore,
              ([] as any[])),i0.ɵmpd(512,i16.BrowserXhr,i16.BrowserXhr,([] as any[])),
          i0.ɵmpd(512,i16.ResponseOptions,i16.BaseResponseOptions,([] as any[])),i0.ɵmpd(1024,
              i16.XSRFStrategy,i16.ɵb,([] as any[])),i0.ɵmpd(512,i16.XHRBackend,i16.XHRBackend,
              [i16.BrowserXhr,i16.ResponseOptions,i16.XSRFStrategy]),i0.ɵmpd(512,i16.RequestOptions,
              i16.BaseRequestOptions,([] as any[])),i0.ɵmpd(1024,i16.Http,i16.ɵc,[i16.XHRBackend,
              i16.RequestOptions]),i0.ɵmpd(1024,i56.TranslateLoader,i47.createWatchlistTranslateLoader,
              [i16.Http]),i0.ɵmpd(512,i57.TranslateCompiler,i57.TranslateFakeCompiler,
              ([] as any[])),i0.ɵmpd(512,i58.TranslateParser,i58.TranslateDefaultParser,
              ([] as any[])),i0.ɵmpd(512,i59.MissingTranslationHandler,i59.FakeMissingTranslationHandler,
              ([] as any[])),i0.ɵmpd(256,i60.USE_DEFAULT_LANG,(undefined as any),([] as any[])),
          i0.ɵmpd(256,i60.USE_STORE,true,([] as any[])),i0.ɵmpd(512,i60.TranslateService,
              i60.TranslateService,[i55.TranslateStore,i56.TranslateLoader,i57.TranslateCompiler,
                  i58.TranslateParser,i59.MissingTranslationHandler,i60.USE_DEFAULT_LANG,
                  i60.USE_STORE]),i0.ɵmpd(512,i61.VehicleSortService,i61.VehicleSortService,
              [i37.Store,i52.WatchListActions,i60.TranslateService,i54.LocalStorageService]),
          i0.ɵmpd(512,i62.VehiclesEffects,i62.VehiclesEffects,[i37.Store,i49.Actions,
              i51.VehiclesService,i53.VehicleFilterService,i61.VehicleSortService,
              i52.WatchListActions,i63.UtilityService,i15.MainStoreService,i64.AppUiActions,
              i40.Router]),i0.ɵmpd(1024,i18.effects,(p0_0:any) => {
            return [p0_0];
          },[i62.VehiclesEffects]),i0.ɵmpd(131584,i18.EffectsSubscription,i18.EffectsSubscription,
              [i37.Store,[3,i18.EffectsSubscription],[2,i18.effects]]),i0.ɵmpd(512,
              i65.EffectsModule,i65.EffectsModule,[i18.EffectsSubscription]),i0.ɵmpd(512,
              i22.StoreDevtoolsModule,i22.StoreDevtoolsModule,([] as any[])),i0.ɵmpd(512,
              i66.NwDealerBlockModule,i66.NwDealerBlockModule,([] as any[])),i0.ɵmpd(512,
              i67.AccordionModule,i67.AccordionModule,([] as any[])),i0.ɵmpd(512,i47.NwWatchlistModule,
              i47.NwWatchlistModule,([] as any[])),i0.ɵmpd(512,i1.WatchlistProxyModule,
              i1.WatchlistProxyModule,([] as any[])),i0.ɵmpd(256,i68.BsDropdownConfig,
              {autoClose:true},([] as any[])),i0.ɵmpd(256,i21.INITIAL_OPTIONS,{},([] as any[])),
          i0.ɵmpd(1024,i40.ROUTES,() => {
            return [[{path:'',component:i69.WatchlistComponent}],[{path:'',component:i69.WatchlistComponent}]];
          },([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9zcmMvbWFpbi9hbmd1bGFyL2FwcC93YXRjaGxpc3Qvd2F0Y2hsaXN0LXByb3h5Lm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL25ldy13YXZlLS1udy1hZGVzYS11aS1waXBlbGluZS9zb3VyY2Uvc3JjL21haW4vYW5ndWxhci9hcHAvd2F0Y2hsaXN0L3dhdGNobGlzdC1wcm94eS5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/main/angular/$$_gendir/app/watchlist/watchlist-proxy.module.ngfactory.ts